import React from 'react';
import { Link } from 'react-router-dom';
import TwitchLink from './twitchLink';
import { prizeWithAmount } from './prizeIcon';

// Top de una liga en la portada. Con leagueLink, el titulo y el "Ver más" del final llevan a
// la clasificacion completa de esa liga en /games. El logo va fuera del h3 para no llevar sus
// margenes; el titulo, si lo hay, va debajo.
const MiniTopComp = ({topData, title, logo, img, pointsName, leagueLink}) => {
    const linked = (content) => leagueLink ? <Link to={leagueLink}>{content}</Link> : content;
    return (
        <div>
            {logo ? linked(logo) : null}
            {title ? <h3>{linked(title)}</h3> : null}
        {topData.map((top, index) => (
            <div>
                <div>#{index+1}</div>
                <div>
                    <Link className='userLink' to={'/user/' + top.displayname}><div>{top.displayname}</div></Link>
                    <TwitchLink displayname={top.displayname} usert={top.usert} useryt={top.useryt}/>
                </div>
                {/* El premio de su puesto; la copa generica solo si la liga no reparte nada. Icono
                    y cantidad van juntos ("x20" son 20 overbox), no como dos piezas sueltas. */}
                <div>{top[pointsName]}{top.prize ? <span className='prizeMiniGroup'>{prizeWithAmount(top.prize, 'prizeImage prizeMini')}</span> : (img ? <img src={img} alt=''></img> : '')}</div>
            </div>
        ))}
            {leagueLink ? <Link className='verMasLiga heroes' to={leagueLink}>Ver más</Link> : null}
        </div>
    );
}

export default MiniTopComp;
